module.exports = __webpack_public_path__ + "static/media/PhoneIcon.e4eae8b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/contact/img/PhoneIcon.svg
// module id = 1121
// module chunks = 2